import { ProgressCircle } from "@adobe/react-spectrum";
import React from "react";
import styles from "./Loader.module.scss";

interface LoaderProps {
  ariaLabel?: string;
  size?: "S" | "M" | "L";
  isIndeterminate?: boolean;
  fullScreen?: boolean;
  style?: object;
}

function Loader({
  ariaLabel = "Loading",
  size = "M",
  isIndeterminate = true,
  fullScreen = false,
  style = {},
}: LoaderProps): JSX.Element {
  return (
    <div
      className={`${fullScreen ? styles.fullScreen : styles.loaderWrapper}`}
      data-testid="wrapper"
    >
      <ProgressCircle
        aria-label={ariaLabel}
        isIndeterminate={isIndeterminate}
        size={size}
        UNSAFE_style={style}
      />
    </div>
  );
}

export default Loader;

Loader.defaultProps = {
  ariaLabel: "",
  size: "M",
  isIndeterminate: true,
  fullScreen: false,
  style: {},
};
